(() => {
	if (window.__dornaStickyCartCleanController) return;
	window.__dornaStickyCartCleanController = true;

	let addPending = false;
	let addedUntil = 0;
	let preserveUntil = 0;
	let resetTimer;

	const visible = (element) => {
		if (!element) return false;
		const rect = element.getBoundingClientRect();
		const style = getComputedStyle(element);
		return rect.width > 1 && rect.height > 1 && style.display !== 'none' && style.visibility !== 'hidden';
	};

	const getControls = () => {
		const active = Array.from(document.querySelectorAll('[data-dorna-size-selector]'))
			.map((selector) => ({ selector, product: selector.closest('.product') }))
			.find((item) => item.product && visible(item.selector) && visible(item.product));
		if (!active) return null;
		return {
			...active,
			desktop: active.product.querySelector('[data-dorna-desktop-sticky]'),
			mobile: active.product.querySelector('[data-dorna-sticky-atc]')
		};
	};

	const getForm = (item) => Array.from(item?.product?.querySelectorAll('form[action*="/cart/add"]') || [])
		.find((form) => visible(form) && !form.closest('floated-form, .product__popup')) || item?.product?.querySelector('form[action*="/cart/add"]');
	const getSelectedSize = (item) => item?.selector.querySelector('input[type="radio"][data-dorna-size-label]:checked');
	const getMainButton = (item) => Array.from(item?.product?.querySelectorAll('.product-form__submit') || [])
		.filter((button) => !button.closest('floated-form, .product__popup'))
		.find(visible);

	const setButton = (button, disabled, label) => {
		if (!button) return;
		button.hidden = false;
		button.style.display = 'inline-flex';
		button.disabled = disabled;
		button.textContent = label;
	};

	const sync = () => {
		const item = getControls();
		if (!item) {
			document.body.classList.remove('dorna-sticky-atc-visible');
			return;
		}
		document.querySelectorAll('[data-dorna-desktop-sticky]').forEach((sticky) => {
			if (sticky !== item.desktop) {
				sticky.hidden = true;
				sticky.classList.remove('is-visible');
			}
		});

		const form = getForm(item);
		const selectedSize = getSelectedSize(item);
		const variantId = form?.querySelector('input[name="id"]')?.value;
		const canSubmit = Boolean(selectedSize && !selectedSize.classList.contains('disabled') && variantId);
		const distanceFromBottom = document.documentElement.scrollHeight - innerHeight - scrollY;
		const mainButton = getMainButton(item);
		const anchor = mainButton?.closest('.product-form__buttons') || mainButton;
		const rect = anchor?.getBoundingClientRect();

		if (item.desktop) {
			const show = innerWidth >= 750 && rect && rect.bottom <= 0 && distanceFromBottom > 80;
			const keep = Date.now() < preserveUntil && distanceFromBottom > 80;
			const isVisible = Boolean(show || keep || item.desktop.classList.contains('is-visible') && addPending);
			item.desktop.hidden = !isVisible;
			item.desktop.classList.toggle('is-visible', isVisible);
			if (isVisible) {
				item.desktop.querySelectorAll('[data-sticky-size]').forEach((sizeButton) => {
					const selected = sizeButton.dataset.stickySize === (selectedSize?.dataset.dornaSizeLabel || '');
					sizeButton.classList.toggle('is-selected', selected);
					sizeButton.setAttribute('aria-pressed', String(selected));
				});
				setButton(item.desktop.querySelector('[data-sticky-submit]'), addPending || !canSubmit, addPending ? 'Adding...' : Date.now() < addedUntil ? 'Added to cart' : 'Add to cart');
			}
		}

		if (item.mobile) {
			const show = innerWidth < 750 && rect && rect.bottom <= 0 && distanceFromBottom > 80;
			item.mobile.hidden = !show;
			item.mobile.classList.toggle('is-visible', show);
			setButton(item.mobile, addPending, addPending ? 'ADDING...' : Date.now() < addedUntil ? 'ADDED TO CART' : selectedSize ? 'ADD TO CART' : 'SELECT SIZE');
			item.mobile.hidden = !show;
			document.body.classList.toggle('dorna-sticky-atc-visible', show);
		}
	};

	const chooseSize = (item, button) => {
		const input = Array.from(item.selector.querySelectorAll('input[type="radio"][data-dorna-size-label]'))
			.find((candidate) => candidate.value === button.dataset.stickySizeValue);
		if (!input || input.disabled || input.classList.contains('disabled')) return;
		preserveUntil = Date.now() + 2500;
		input.checked = true;
		input.dispatchEvent(new Event('change', { bubbles: true }));
		sync();
	};

	const showAdded = () => {
		addPending = false;
		addedUntil = Date.now() + 2500;
		preserveUntil = Date.now() + 3000;
		clearTimeout(resetTimer);
		resetTimer = setTimeout(() => { addedUntil = 0; sync(); }, 2500);
		sync();
	};

	const submit = (item) => {
		const selectedSize = getSelectedSize(item);
		const form = getForm(item);
		if (!selectedSize || selectedSize.classList.contains('disabled') || !form?.querySelector('input[name="id"]')?.value) {
			item.selector.scrollIntoView({ behavior: 'smooth', block: 'center' });
			return;
		}
		selectedSize.dispatchEvent(new Event('change', { bubbles: true }));
		let quantity = form.querySelector('input[name="quantity"]');
		if (!quantity) {
			quantity = document.createElement('input');
			quantity.type = 'hidden';
			quantity.name = 'quantity';
			form.appendChild(quantity);
		}
		quantity.value = String(Math.max(1, parseInt(item.desktop?.querySelector('[data-sticky-qty]')?.value || '1', 10) || 1));
		addPending = true;
		preserveUntil = Date.now() + 7000;
		sync();
		if (form.requestSubmit) form.requestSubmit();
		else getMainButton(item)?.click();
	};

	document.addEventListener('click', (event) => {
		const target = event.target instanceof Element ? event.target.closest('[data-sticky-size], [data-sticky-submit], [data-dorna-sticky-atc]') : null;
		if (!target) return;
		const item = getControls();
		if (!item || !item.desktop?.contains(target) && item.mobile !== target) return;
		event.preventDefault();
		event.stopImmediatePropagation();
		if (target.matches('[data-sticky-size]')) chooseSize(item, target);
		else submit(item);
	}, true);

	document.addEventListener('variant:add', showAdded);
	document.addEventListener('cart:updated', () => { if (addPending) showAdded(); });
	document.addEventListener('cart:error', () => { addPending = false; sync(); });
	addEventListener('scroll', sync, { passive: true });
	addEventListener('resize', sync);
	document.addEventListener('variant:change', sync);
	document.addEventListener('variant:changed', sync);
	setInterval(sync, 300);
	sync();
})();
